import en from "date-fns/locale/en-US";
import ko from "date-fns/locale/ko";
import { useEffect, useState } from "react";
import { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useTranslation } from "react-i18next";
import "react-toastify/dist/ReactToastify.css";
import {
  Card,
  Col,
  Modal,
  ModalBody,
  ModalHeader,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
} from "reactstrap";
import JobPostInfo from "./component/JobPostInfo";
import applicationApi from "api/applicationApi";
import ApplicationInfo from "./component/ApplicationInfo";
import ApplicationStatus from "./component/ApplicationStatus";

export interface Props {
  isOpen: boolean;
  item?: any;
  setLinkImage?: any;
  triggerRefresh?: () => void;
  onClose?: () => void;
}

registerLocale("en", en);
registerLocale("ko", ko);

const UserDetail = ({ isOpen, item, setLinkImage, triggerRefresh, onClose }: Props) => {
  const { t, i18n } = useTranslation();
  const [activeTab, setActiveTab] = useState("JOB_POST_INFO");
  const [dataProfile, setDataProfile] = useState<any>(null);

  const tabChange = (tab: any) => {
    if (activeTab !== tab) {
      setActiveTab((_prev) => tab);
    }
  };

  const onCloseClick = () => {
    setActiveTab("JOB_POST_INFO");
    onClose && onClose();
  };

  const handleUpdateSuccess = async () => {
    if (!item?.id) return;

    try {
      const response: any = await applicationApi.getDetails(item?.id);
      if (response?.data) {
        setDataProfile(response?.data);
      }
    } catch (error) {
      console.log(error);
    }
    triggerRefresh && triggerRefresh();
  };

  const isGuest = () => {
    if (dataProfile?.user_device?.login_type === "GUEST") return true;

    return false;
  };

  const initData = async () => {
    try {
      const response: any = await applicationApi.getDetails(item?.id);
      if (response?.data) {
        setDataProfile(response?.data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (item) {
      initData();
    }
  }, [item]);

  return (
    <Modal isOpen={isOpen} centered={true} size="xl" scrollable={true}>
      <ModalHeader toggle={onCloseClick}>{t("Detail Application")}</ModalHeader>
      <ModalBody className="pt-0">
        <div style={{ minHeight: "calc(100dvh - 200px)" }} className="detail-section">
          <Col lg={12}>
            <Card
              id="JOB_POST_INFO"
              style={{
                boxShadow: "0px 3px 4px 0px rgba(0, 0, 0, 0.03)",
                borderTop: "unset",
              }}
            >
              <div
                style={{
                  background: "#f3f6f9",
                  borderTopLeftRadius: "0.6rem",
                  borderTopRightRadius: "0.6rem",
                  position: "sticky",
                  top: "0px",
                  zIndex: 99,
                  borderTop: "1px solid #e9ebec",
                }}
              >
                <div
                  className="d-block"
                  style={{
                    background: "#f3f6f9",
                    borderRadius: "0.6rem",
                    width: "fit-content",
                  }}
                >
                  <Nav
                    tabs
                    className="nav nav-tabs nav-link-none-hover nav-justified"
                  >
                    <NavItem style={{ textWrap: "nowrap" }}>
                      <NavLink
                        style={{
                          cursor: "pointer",
                          background: `${
                            activeTab === "JOB_POST_INFO"
                              ? "var(--vz-primary)"
                              : "unset"
                          }`,
                          color: `${
                            activeTab === "JOB_POST_INFO" ? "white" : "unset"
                          }`,
                          borderTopRightRadius: 0,
                        }}
                        onClick={() => tabChange("JOB_POST_INFO")}
                      >
                        {t("Job Post Info")}
                      </NavLink>
                    </NavItem>
                    <NavItem style={{ textWrap: "nowrap" }}>
                      <NavLink
                        style={{
                          cursor: `${isGuest() ? "default" : "pointer"}`,
                          background: `${
                            activeTab === "APPLICATION_INFO"
                              ? "var(--vz-primary)"
                              : "unset"
                          }`,
                          color: `${
                            activeTab === "APPLICATION_INFO"
                              ? "white"
                              : isGuest()
                              ? "gray"
                              : "unset"
                          }`,
                          borderTopLeftRadius: 0,
                          borderTopRightRadius: 0,
                        }}
                        onClick={() => {
                          if (isGuest()) return;

                          tabChange("APPLICATION_INFO");
                        }}
                      >
                        {t("Application Info")}
                      </NavLink>
                    </NavItem>
                    <NavItem style={{ textWrap: "nowrap" }}>
                      <NavLink
                        style={{
                          cursor: `${isGuest() ? "default" : "pointer"}`,
                          background: `${
                            activeTab === "APPLICATION_STATUS"
                              ? "var(--vz-primary)"
                              : "unset"
                          }`,
                          color: `${
                            activeTab === "APPLICATION_STATUS"
                              ? "white"
                              : isGuest()
                              ? "gray"
                              : "unset"
                          }`,
                          borderTopLeftRadius: 0,
                          borderTopRightRadius: 0,
                        }}
                        onClick={() => {
                          if (isGuest()) return;

                          tabChange("APPLICATION_STATUS");
                        }}
                      >
                        {t("Application Status")}
                      </NavLink>
                    </NavItem>
                  </Nav>
                </div>
              </div>
              <TabContent activeTab={activeTab}>
                <TabPane tabId="JOB_POST_INFO">
                  {activeTab === "JOB_POST_INFO" && (
                    <JobPostInfo data={dataProfile} setLinkImage={setLinkImage} />
                  )}
                </TabPane>
                <TabPane tabId="APPLICATION_INFO">
                  {activeTab === "APPLICATION_INFO" && (
                    <ApplicationInfo data={dataProfile} />
                  )}
                </TabPane>
                <TabPane tabId="APPLICATION_STATUS">
                  {activeTab === "APPLICATION_STATUS" && (
                    <ApplicationStatus
                      data={dataProfile}
                      handleUpdateSuccess={handleUpdateSuccess}
                    />
                  )}
                </TabPane>
              </TabContent>
            </Card>
          </Col>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default UserDetail;
